// extracted by mini-css-extract-plugin
module.exports = {"colorSwatch":"ColorSwatch_colorSwatch","box":"ColorSwatch_box","title":"ColorSwatch_title","color":"ColorSwatch_color"};